/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EventoComunicazioneConfigurabileDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaEventoComunicazioneDTO } from '../model/models';
import { TipoPraticaEventoComunicazioneCreationForm } from '../model/models';
import { TipoPraticaEventoComunicazioneDTO } from '../model/models';
import { TipoPraticaEventoComunicazioneListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaEventoComunicazioneRequestParams {
    idTipoPratica: string;
    tipoPraticaEventoComunicazioneCreationForm: TipoPraticaEventoComunicazioneCreationForm;
}

export interface DeleteTipoPraticaEventoComunicazioneRequestParams {
    idTipoPratica: string;
    idEvento: string;
}

export interface GetTipoPraticaEventiComunicazioneConfigurabiliRequestParams {
    idTipoPratica: string;
}

export interface ListTipoPraticaEventiComunicazioneRequestParams {
    idTipoPratica: string;
    filter: TipoPraticaEventoComunicazioneListFilter;
    pageable: Pageable;
}


export interface TipoPraticaEventoComunicazioneControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo evento di comunicazione (auto-materializza i 3 canali figli)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione
* @param requestParameters
     */
    createTipoPraticaEventoComunicazione(requestParameters: CreateTipoPraticaEventoComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaEventoComunicazioneDTO>;

    /**
     * Elimina un evento di comunicazione (cascade sui 3 figli)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/{idEvento}
* @param requestParameters
     */
    deleteTipoPraticaEventoComunicazione(requestParameters: DeleteTipoPraticaEventoComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Discovery degli eventi di comunicazione configurabili per il bando
     * Partizione autoritativa per dominio (CITTADINO/ESERCENTE): il FE non filtra per prefisso stringa. Gli eventi ESERCENTE_* compaiono solo se il bando ha il modulo esercenti abilitato e la tipologia è ammessa.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/configurabili
* @param requestParameters
     */
    getTipoPraticaEventiComunicazioneConfigurabili(requestParameters: GetTipoPraticaEventiComunicazioneConfigurabiliRequestParams, extraHttpRequestParams?: any): Observable<Array<EventoComunicazioneConfigurabileDTO>>;

    /**
     * Lista paginata degli eventi di comunicazione (filtro: evento)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione
* @param requestParameters
     */
    listTipoPraticaEventiComunicazione(requestParameters: ListTipoPraticaEventiComunicazioneRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaEventoComunicazioneDTO>;

}
